<template>
  <section class="page-dashbord-comments pt-3 mb-3">
    <app-loading :isFull="true" v-if="isLoading" />
    <vue-modaltor
      :visible="isModal"
      @hide="hideModal"
      :default-width="'50%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width='{1200:"60%",992:"80%",768:"90%"}'
    >
      <app-loading :isFull="false" v-if="isLoading" />
      <div v-if="itemUpdate" class="pt-3">
        <div class="row">
          <div class="col-8">
            <div class="start-box rtl text-right">
              <label class="statr">امتیاز شما به این دوره</label>
              <div class="clearfix"></div>
              <star-rating
                class="d-inline-block"
                :rtl="true"
                :star-size="20"
                :show-rating="false"
                v-model="itemUpdate.item.rate"
                :active-color="'#f4c150'"
                :rounded-corners="false"
                :inactive-color="'#ccc'"
              />
              <p class="d-inline-block rtl text-right">{{itemUpdate.item.rate}}</p>
            </div>
          </div>
          <div class="col-4">
            <div class="input-checkbox rtl text-right">
              <div class="md-checkbox">
                <input type="checkbox" id="published" v-model="itemUpdate.item.published" />
                <label for="published" class="font-14">پابلیش</label>
              </div>
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="group-form">
              <textarea
                type="text"
                v-validate="'required'"
                name="content"
                :class="{active:itemUpdate.item.content != '' }"
                v-model="itemUpdate.item.content"
              ></textarea>
              <span class="bar"></span>
              <label class="statr">متن سوال</label>
              <span v-if="errors.has('content')" class="is-danger">فیلد نباید خالی باشد</span>
            </div>
          </div>
          <div class="col-4">
            <div class="form-action my-2">
              <button
                class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                v-ripple
                @click="updateComment"
              >بروزرسانی نظر</button>
            </div>
          </div>
        </div>
      </div>
    </vue-modaltor>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <header>
            <h2 class="rtl text-right mb-2 font-20">{{$t('word.comments')}}</h2>
          </header>
          <b-card no-body>
            <b-tabs card>
              <b-tab title="نظرات پابلیش شده" @click="getComment(true)">
                <div v-for="(value, name,index) of _comments">
                  <div class="card-header rtl text-right" v-b-toggle="'div'+index">
                    <toggle-open />
                    <p class="card-title">{{ name }}</p> 
                  </div>
                  <b-collapse
                    :id="'div'+index"
                    :visible="index === expanded"
                    accordion="my-accordion"
                  >
                    <div class="content px-2 py-3">
                      <comments
                        :isAdmin="true"
                        @editComment="editComment(comment,index)"
                        @removeComment="removeComment(comment,index)"
                        :item="comment"
                        v-for="(comment,index) in value"
                        :key="comment.id"
                      />
                    </div>
                  </b-collapse>
                </div>
              </b-tab>
              <b-tab title="نظرات پابلیش نشده" @click="getComment(false)">
                <div v-for="(value, name,index) of _comments">
                  <div class="card-header rtl text-right" v-b-toggle="'div'+index">
                    <toggle-open />
                    <p class="card-title">{{ name }}</p> 
                  </div>
                  <b-collapse
                    :id="'div'+index"
                    :visible="index === expanded"
                    accordion="my-accordion"
                  >
                    <div class="content px-2 py-3">
                      <comments
                        :isAdmin="true"
                        @editComment="editComment(comment,index)"
                        @removeComment="removeComment(comment,index)"
                        :item="comment"
                        v-for="(comment,index) in value"
                        :key="comment.id"
                      />
                    </div>
                  </b-collapse>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import comments from "cp/comments.vue";
import toggleOpen from "cp/min-component/open-colose.vue";
import _ from "underscore";
export default {
  name: "page-dashbord-comments",
  components: {
    comments,
    toggleOpen
  },
  data() {
    return {
      expanded: 0,
      isLoading: true,
      isModal: false,
      itemUpdate: null
    };
  },
  computed: {
    comments() {
      return this.$store.state.dashboardComments.comments;
    },
    _comments() {
      let items = this.comments;
      return _.groupBy(items, e => e.course_title);
    }
  },
  mounted() {
    this.getComment(true);
  },
  methods: {
    hideModal() {
      this.isModal = false;
      this.itemUpdate = null;
    },
    async getComment(publish) {
      this.isLoading = true;
      await this.$store.dispatch("dashboardComments/getComments", { publish });
      this.isLoading = false;
    },
    editComment(item, index) {
      this.itemUpdate = { item, index };
      this.isModal = true;
    },
    async removeComment(item, index) {
      this.isLoading = true;
      await this.$store.dispatch("dashboardComments/remove", { id: item.id });
      this.$delete(this.comments, index);
      this.isLoading = false;
    },
    async updateComment() {
      this.isLoading = true;
      await this.$store.dispatch("dashboardComments/update", {
        item: this.itemUpdate.item
      });
      this.isLoading = false;
      if (!this.itemUpdate.item.published) {
        this.$delete(this.comments, this.itemUpdate.index);
      }
      this.hideModal();
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-comments {
  .box-clear;
  .panel-body-header {
    background: #f9f9f9;
    color: @secondaryTextColor;
  }
  .card-title {
    margin-bottom: 0;
    width: 100%;
  }
  .card-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: #f9f9f9;
    border: 1px solid @e3;
    cursor: pointer;
    height: auto;
    margin-top: 3px;
    padding: 10px 15px 10px 10px;
    color: @secondaryTextColor;
    i {
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/comments.vue